import { ReactElement } from 'react'
import {
  POSITION_LIST_PLAN_TABLE_TEMPLATE_KEY,
  SHEAR_ANCHORS_PLAN_TABLE_TEMPLATE_KEY,
  TENSILE_ANCHORS_PLAN_TABLE_TEMPLATE_KEY,
} from 'src/domain/planTables/constants'
import type { PlanTableTemplateOptions } from 'src/domain/planTables/types'
import PositionListTemplateOptionsFields from './PositionListTemplateOptionsFields'
import ShearAnchorsTemplateOptionsFields from './ShearAnchorsTemplateOptionsFields'
import TensileAnchorsTemplateOptionsFields from './TensileAnchorsTemplateOptionsFields'

interface Props {
  templateKey: string | null | undefined
  templateOptions: PlanTableTemplateOptions | undefined
  onChange: (templateOptions: PlanTableTemplateOptions) => void
}

/** The options of a template table, for the templates that have any. */
const PlanTableTemplateOptionsFields = ({
  templateKey,
  templateOptions,
  onChange,
}: Props): ReactElement | null => {
  if (templateKey === POSITION_LIST_PLAN_TABLE_TEMPLATE_KEY) {
    return (
      <PositionListTemplateOptionsFields templateOptions={templateOptions} onChange={onChange} />
    )
  }
  if (templateKey === TENSILE_ANCHORS_PLAN_TABLE_TEMPLATE_KEY) {
    return (
      <TensileAnchorsTemplateOptionsFields templateOptions={templateOptions} onChange={onChange} />
    )
  }
  if (templateKey === SHEAR_ANCHORS_PLAN_TABLE_TEMPLATE_KEY) {
    return (
      <ShearAnchorsTemplateOptionsFields templateOptions={templateOptions} onChange={onChange} />
    )
  }
  return null
}

export default PlanTableTemplateOptionsFields
